import React, { useEffect, useState, useRef } from 'react';
import "./index.scss";
import YouTube from 'react-youtube';


import AppTool from '@utils/app-tool';

const VideoPlayerDialog = (props) => {
  const videoRef = useRef(null);
  const [videoWidth, setVideoWidth] = useState(560)
  const [videoHight, setVideoHight] = useState(315)

  const onReady = (event) => {
    // 访问到 YouTube 播放器实例
    console.log(event.target);
    videoRef.current = event.target;
  };

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pauseVideo(); // 调用 pauseVideo 方法来暂停视频
    }
    AppTool.closeDialog('.cVideoPlayerDialog')
  };

  useEffect(() => {
    // 計算螢幕寬度
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    let isPhone = false;
    if (window.innerWidth < 1040) {
      isPhone = true;
    }
    setVideoWidth(screenWidth * (isPhone ? 0.9 : 0.6));
    setVideoHight( isPhone ? screenHeight * 0.9 :(screenWidth * 0.6 * 315 / 560));

    window.addEventListener('resize', () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let isPhone = false;
      if (window.innerWidth < 1040) {
        isPhone = true;
      }
      setVideoWidth(screenWidth * (isPhone ? 0.9 : 0.6));
      setVideoHight( isPhone ? screenHeight * 0.9 :(screenWidth * 0.6 * 315 / 560));
    });
  }, []);


  return (
    <div className="cVideoPlayerDialog cDialogAttr" >
      <div className="cMask" onClick={() => { handleClose() }}></div>
      <div className="cDialog" >
        <YouTube videoId="l2cdqn27Z3M" opts={{
          height: videoHight,
          width: videoWidth,
        }} onReady={onReady} />
      </div>
    </div>
  )
}

export default VideoPlayerDialog;